import { useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import HttpErrorHelper from 'utils/HttpErrorHelper';
import useToaster from 'utils/hooks/useToaster';
import { addMinutes } from 'date-fns';
import Style from './index.module.css';
import EnhetsgrupperingApi from 'services/KjederegisteretAdminApi/EnhetsgrupperingApi';
import {
  Enhetgruppering,
  Medlemskjede,
  MeldUtMedlemskjedeCommand,
} from 'services/KjederegisteretAdminApi/EnhetsgrupperingApi/types';
import { NorwegianDatepicker } from 'components/NorwegianDatepicker';

interface Props {
  enhetsgruppe: Enhetgruppering;
  kjedeMedlem?: Medlemskjede;
  showModal: boolean;
  handleCloseModal: () => void;
}

const AvsluttKjedeMedlemskapModal = (props: Props) => {
  const [selectedUtmeldingsDato, setSelectedUtmeldingsDato] = useState<Date>(
    addMinutes(new Date(), -new Date().getTimezoneOffset()),
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const toaster = useToaster();

  const handleSubmit = () => {
    if (!props.kjedeMedlem) {
      return;
    }

    const command: MeldUtMedlemskjedeCommand = {
      kjedeEnhetgrupperingID: props.kjedeMedlem.kjedeEnhetgrupperingId,
      tilOgMedDato: selectedUtmeldingsDato,
    };
    setIsLoading(true);
    EnhetsgrupperingApi.meldUtMedlemskjede(props.enhetsgruppe.enhetgrupperingID, command)
      .then(() => {
        toaster.success('Suksess!', 'Kjede ble meldt ut.');
      })
      .catch((err) => {
        toaster.error('Feil! Kunne ikke melde ut kjede.', HttpErrorHelper.formatError(err));
      })
      .finally(() => {
        props.handleCloseModal();
        setIsLoading(false);
      });
  };

  const submitDisabled = isLoading || !selectedUtmeldingsDato;

  return (
    <Modal show={props.showModal} onHide={props.handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          Meld {props.kjedeMedlem?.kjedeNavn} ut av {props.enhetsgruppe.enhetsgrupperingnavn}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Utmeldingsdato</Form.Label>
            <NorwegianDatepicker
              value={selectedUtmeldingsDato}
              onChange={(date: Date) => setSelectedUtmeldingsDato(date)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className={Style.modalFooter}>
        <div>
          <Button
            className={Style.closeModalBtn}
            variant="secondary"
            onClick={props.handleCloseModal}
          >
            Lukk
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={submitDisabled}>
            Meld ut
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AvsluttKjedeMedlemskapModal;
